import React, { useState } from 'react'
import { DialogContent, DialogHeader, DialogTitle } from '@/Components/ui/dialog'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { Form, FormControl, FormField, FormItem, FormLabel } from '@/Components/ui/form'
import { Input } from '@/Components/ui/input'
import { Button } from '@/Components/ui/button'
import { toast } from 'react-toastify'
import Loader from '@/Components/Common/Loader'
import { useNavigate } from 'react-router-dom'
import WorkflowActionService from '@/Service/WorkflowActionService'

const CreateWorkflowAction = ({ getWorkflowAction, setIsOpen }) => {
    const navigate = useNavigate()
    const formSchema = z.object({
        action: z
            .string({
                message: 'Workflow Action is required.',
            })
            .min(1, {
                message: 'Workflow Action is required.',
            }),
    })
    const [isSaving, setIsSaving] = useState(false)

    const form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            action: '',
        },
    })

    async function onSubmit(values) {
        try {
            setIsSaving(true)
            const resp = await WorkflowActionService.addWorkflowAction(values)
            if (resp.data.success) {
                setIsSaving(false)
                const searchParams = new URLSearchParams(location.search)
                const page = searchParams.get('page')
                if (page) {
                    navigate('/workflow/action')
                } else {
                    getWorkflowAction()
                }
                form.reset({ action: '' })
                setIsOpen(false)
            }
        } catch (err) {
            setIsSaving(false)
        }
    }

    function onError(errors, e) {
        const errorKeys = Object.keys(errors)
        if (errorKeys.length > 0 && errors[errorKeys[0]]?.message) {
            toast.error(errors[errorKeys[0]].message)
        }
        console.log(errors, e)
    }

    return (
        <DialogContent>
            <DialogHeader>
                <DialogTitle>Add Action</DialogTitle>
            </DialogHeader>
            <div>
                <Form {...form}>
                    <form onSubmit={form.handleSubmit(onSubmit, onError)} className="space-y-4">
                        <FormField
                            control={form.control}
                            name="action"
                            render={({ field }) => (
                                <FormItem className="space-y-1">
                                    <FormLabel required={true}>Action</FormLabel>
                                    <FormControl>
                                        <Input
                                            {...field}
                                            className="shadow-none focus-visible:ring-transparent space-0 mt-0"
                                            placeholder="Action"
                                        />
                                    </FormControl>
                                </FormItem>
                            )}
                        />
                        <div className="flex justify-end">
                            <Button type="submit" className="bg-primary-purpal hover:bg-primary-purpal " disabled={isSaving}>
                                Save {isSaving && <Loader fullScreen={false} />}
                            </Button>
                        </div>
                    </form>
                </Form>
            </div>
        </DialogContent>
    )
}

export default CreateWorkflowAction
